
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export  class NotesTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Студия"),
                dataIndex: 'salon.name',
                key: '0',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Косметолог"),
                dataIndex: 'staff.last_name',
                key: '1',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: (text: any, record: any, index: number) => {
                        return `${record.staff.last_name} ${record.staff.name}`
                    },
                },
            },
            {
                title: i18nText("Создал"),
                dataIndex: 'author.name',
                key: '2',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Услуга"),
                dataIndex: 'services[0].name',
                key: '3',
                /*scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },*/
            },
            {
                title: i18nText("Статус"),
                key: '4',
                dataIndex: 'status',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'active'
                },
            },
            {
                title: i18nText("Дата визита"),
                dataIndex: 'visit_dt',
                key: '5',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    }
}
